export default function Flow() {
  const steps = [
    {
      number: '01',
      icon: 'ri-mail-send-line',
      title: 'お問い合わせ',
      description: 'お電話またはWebフォームから、お気軽にお問い合わせください。'
    },
    {
      number: '02',
      icon: 'ri-map-pin-line',
      title: '現地調査',
      description: '専門スタッフが現地を訪問し、設備の状況を詳しく調査いたします。'
    },
    {
      number: '03',
      icon: 'ri-file-list-3-line',
      title: 'お見積もり',
      description: '調査結果をもとに、詳細なお見積もりを作成してご提案いたします。'
    },
    {
      number: '04',
      icon: 'ri-tools-fill',
      title: '作業実施',
      description: 'ご承認後、経験豊富なスタッフが丁寧に作業を実施いたします。'
    },
    {
      number: '05',
      icon: 'ri-checkbox-circle-line',
      title: '完了・引き渡し',
      description: '作業完了後、動作確認を行い、お客様にご確認いただきます。'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-cyan-50/30 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block bg-cyan-100 text-cyan-700 px-4 py-2 rounded-full text-sm font-semibold mb-4">
            Service Flow
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-800 mb-4">
            ご利用の流れ
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            お問い合わせから作業完了まで、スムーズな5ステップ
          </p>
        </div>

        <div className="relative">
          {/* Desktop Flow */}
          <div className="hidden lg:block">
            <div className="flex items-start justify-between relative">
              {/* Connection Line */}
              <div className="absolute top-16 left-0 right-0 h-1 bg-gradient-to-r from-cyan-200 via-cyan-400 to-cyan-200" style={{ width: 'calc(100% - 120px)', left: '60px' }}></div>
              
              {steps.map((step, index) => (
                <div key={index} className="flex flex-col items-center relative z-10" style={{ width: '180px' }}>
                  <div className="bg-white border-4 border-cyan-500 w-32 h-32 flex items-center justify-center rounded-full mb-4 shadow-lg group-hover:scale-110 transition-transform">
                    <i className={`${step.icon} text-4xl text-cyan-600`}></i>
                  </div>
                  <div className="bg-cyan-600 text-white text-sm font-bold px-3 py-1 rounded-full mb-3">
                    STEP {step.number}
                  </div>
                  <h3 className="text-lg font-bold text-slate-800 mb-2 text-center">
                    {step.title}
                  </h3>
                  <p className="text-sm text-slate-600 text-center leading-relaxed">
                    {step.description}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Mobile Flow */}
          <div className="lg:hidden space-y-6">
            {steps.map((step, index) => (
              <div key={index} className="flex items-start space-x-4 bg-white p-6 rounded-lg shadow-md">
                <div className="flex-shrink-0">
                  <div className="bg-cyan-100 w-16 h-16 flex items-center justify-center rounded-full">
                    <i className={`${step.icon} text-2xl text-cyan-600`}></i>
                  </div>
                </div>
                <div className="flex-1">
                  <div className="bg-cyan-600 text-white text-xs font-bold px-2 py-1 rounded-full inline-block mb-2">
                    STEP {step.number}
                  </div>
                  <h3 className="text-lg font-bold text-slate-800 mb-2">
                    {step.title}
                  </h3>
                  <p className="text-sm text-slate-600 leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 text-center">
          <button 
            onClick={() => {
              const element = document.getElementById('contact');
              if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
              }
            }}
            className="bg-cyan-600 text-white px-8 py-4 rounded-md font-semibold hover:bg-cyan-700 transition-all shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
          >
            まずはお問い合わせ
          </button>
        </div>
      </div>
    </section>
  );
}
